import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  placeholderContainer: theme => ({
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.activeColor,
    width: 25,
    height: 25,
    borderRadius: 12.5,
  }),
  placeholderText: theme => ({
    alignSelf: 'center',
    color: theme.colors.activeColorTwo,
    fontSize: 15,
    lineHeight: 20,
    textTransform: 'uppercase',
    paddingHorizontal: 3.5,
    paddingTop: Platform.OS === 'ios' ? 3.5 : 0,
  }),
});
